import clone from 'clone'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

export const initialState = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  policyMode: '',
  policyGeneralSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  // policyGeneral: {
  //   init: 0,
  //   menu: {},
  //   saving: false,
  //   saveError: {
  //     fieldMessages: [],
  //     messages: []
  //   }
  // },
  policy: {
    init: 0,
    menu: {},
    saving: false,
    saveError: {
      fieldMessages: [],
      messages: []
    },
    // Policy Life Cycle state. Controls the steps within the Policy. Starts off as 1 but 0 is reserved for New Policy.
    policyLifeCycle: 1,
    policyHeaderTab: 0,
    policyRiskTab: 0,
    policySummaryTab: 0,
    policyReinsuranceTab: 0,
    policyRiData: undefined,
    promptWhenExit: true,
    policyInfo: {
      polNo: undefined,
      renCnt: undefined,
      endtCnt: undefined,
      polTypeDesc: undefined,
      branchDesc: undefined,
      fundDesc: undefined,
      fromDate: undefined,
      endDate: undefined,
      uwYear: undefined,
      insured: undefined,
      // OS-411: Added 17-Sep-2020
      polStatDesc: undefined,
      name: undefined,
      ctyDesc: undefined,
      fundDescription: undefined,
      deptDesc: undefined,
      busSrcDesc: undefined,
      paytMethDesc: undefined,
      finInstName: undefined,
      armName: undefined,
      createdName: undefined,
      modifiedName: undefined,
      cedAntName: undefined,
      acctNoSfxDesc: undefined,
      schemeDesc: undefined
    },
    polMaster: {
      // polNo: undefined,
      // renCnt: 0,
      // endtCnt: 0,
      // tranDate: undefined,
      // endtDate: undefined,
      // dri: undefined,
      // appCoIns: undefined,
      // branch: undefined,
      // polType: undefined,
      // busSrc: undefined,
      // billType: undefined,
      // comDate: undefined,
      // expDate: undefined,
      // uwYr: undefined,
      // firstIssDate: undefined,
      // acceptDate: undefined,
      // acceptTime: undefined
      // *****
      // insdRefNoAE: true,
      polNo: undefined,
      renCnt: 0,
      endtCnt: 0,
      clientType: '',
      tranDate: undefined,
      acceptDate: undefined,
      acceptTime: 0,
      acct1DocNo: '',
      acct1TranType1: '',
      acct2DocNo: '',
      acct2TranType1: '',
      acct3DocNo: '',
      acct3TranType1: '',
      acctNo1: '',
      acctNo2: '',
      acctNo3: '',
      agent: '',
      acctYr: 0,
      acctMth: 0,
      appCoIns: undefined,
      billCoIns: '',
      coInsPct: 0,
      appRiskTax: false,
      appShortTerm: false,
      batchRel: false,
      billCurr: '',
      billCurrRate: 0,
      branch: '',
      busSrc: '',
      cedAnt: '',
      acctNoSfx: '',
      cedPolNo: '',
      cedCesNo: '',
      cedSI: 0,
      ourSharePct: 0,
      cnType: '',
      cnNo: '',
      cnDate: undefined,
      comDate: undefined,
      comm1: 0,
      comm2: 0,
      comm3: 0,
      cty: '',
      dept: '',
      disc: 0,
      dri: true,
      endtDate: undefined,
      endtSeqNo: '',
      entDate: undefined,
      entUsrId: 0,
      expDate: undefined,
      finInst: '',
      firstIssDate: undefined,
      fund: '',
      genPolNo: true,
      gstStatPrem: '',
      gstStatComm1: '',
      gstStatComm2: '',
      gstStatComm3: '',
      gstRatePrem: 0,
      gstRateComm1: 0,
      gstRateComm2: 0,
      gstRateComm3: 0,
      gstAEPrem: true,
      gstAEComm1: true,
      gstAEComm2: true,
      gstAEComm3: true,
      gstPrem: 0,
      gstComm1: 0,
      gstComm2: 0,
      gstComm3: 0,
      gstStatRateAEPrem: true,
      gstStatRateAEComm1: true,
      gstStatRateAEComm2: true,
      gstStatRateAEComm3: true,
      issDate: undefined,
      noCIPrt: 0,
      noDrCrPrt: 0,
      noTaxInvPrt: 0,
      noRiApplnPrt: 0,
      noSchedPrt: 0,
      occupation: '',
      moCmpNo: '',
      paytMeth: '',
      polEndtTxt: '',
      polFee: 0,
      polLwrTxt: '',
      polMemo: '',
      polPd: 0,
      polGap: 0,
      polRenTxt: '',
      polRenMsg: '',
      polStamp: 0,
      polStat: '',
      polTax: 0,
      polType: '',
      polUppTxt: '',
      prevInsr: '',
      progId: '',
      prtCILn: false,
      prtDrCrLn: false,
      prtRiApplnLn: false,
      prtSchedLn: false,
      rcptNo: '',
      recip: '',
      redBal1: false,
      redBal2: false,
      redBal3: false,
      relDate: undefined,
      relUsrId: '',
      renPolNo: '',
      riskFee: 0,
      riskStamp: 0,
      riskTax: 0,
      prevPolNo: '',
      prevPolExpDate: undefined,
      renSeqNo: '',
      retroDate: undefined,
      riFac: false,
      schedForm: '',
      schedPremHead: '',
      scheme: '',
      promotion: '',
      securGrp: '',
      termDate: undefined,
      totNoInstal: 1,
      tranRel: false,
      tranType: '',
      uwYr: 0,
      endtType: '',
      dateRenPrt: undefined,
      discLdg1: 0,
      discLdg2: 0,
      discLdg3: 0,
      endtForm: '',
      prtDiscLdg1: false,
      prtDiscLdg2: false,
      prtDiscLdg3: false,
      redBalDiscLdg2: false,
      redBalDiscLdg3: false,
      cpId: '',
      cpBrn: '',
      schedPrt: false,
      drCrPrt: false,
      riLvl: '',
      discCommLvl: '',
      insdRefNo: '',
      titleName: '',
      firstName: '',
      insdName1: '',
      insdName2: '',
      insdName3: '',
      insdAddr1: '',
      insdAddr2: '',
      insdAddr3: '',
      insdAddr4: '',
      postCode: '',
      icNo: '',
      telNo1: '',
      telNo2: '',
      mobile: '',
      fax: '',
      email: '',
      drCrNo: true,
      modDate: undefined,
      modUsrId: 0,
      grpPol: false,
      grpNamedPol: false,
      empCont: false,
      depdCont: false,
      stdBenRate: false,
      prtSchedInsd: false,
      prtSchedBen: false,
      prtSchedPrem: false,
      execIC: '',
      coRiPct: 0,
      maintPer: 0,
      prtInsdDr: false,
      industry: '',
      insBondNo: '',
      totNoWrkmen: 0,
      paiExpDate: undefined,
      medPolNo: '',
      cedAcctNoSfx: '',
      dliabPer: 0,
      tpBill: false,
      phCltGrp: '',
      isPhGstReg: false,
      gstRegNo: '',
      gstRegDate: undefined,
      polStampAE: true,
      polFeeAE: true,
      polTaxAE: true,
      prtSubTaxInv: true,
      premWar: '',
      convEntUsrId: '',
      convRelUsrId: '',
      brkSlipNo: '',
      brkTranRef: '',
      prtVarDesc: '',
      acctNo2Sfx: '',
      acctNo3Sfx: '',
      agentAcctNoSfx: '',
      insdAddr5: '',
      insdAddr6: '',
      discLdg1Code: '',
      discLdg2Code: '',
      discLdg3Code: '',
      insdName4: '',
      moCmpUpld: false,
      recHash: '',
      prtTaxInvLn: false,
      nxtBillMth: 0,
      billType: '',
      contractExpDate: undefined,
      cpCode: '',
      ccaDate: undefined,
      ccdDate: undefined,
      insdRefNoAE: undefined,
      insdStat: undefined,
      nationality: undefined,
      icNoROC: undefined,
      altName1: undefined,
      altName2: undefined,
      sameInsdAddr: undefined,
      altInsdAddr1: undefined,
      altInsdAddr2: undefined,
      altInsdAddr3: undefined,
      altInsdAddr4: undefined,
      altInsdAddr5: undefined,
      altInsdAddr6: undefined,
      altPostCode: undefined,
      agtUsrId: undefined,
      gender: '',
      dob: undefined,
      normOnRel: false,
      endtCode: '',
      cancelCode: '',
      entRilater: false,
      ipcStatus: '',
      ipcNo: '',
      ipcSeqNo: '',
      ipcDate: undefined,
      ourShareSi: 0,
      ccDateEntDate: null,
      ccDateEntUsrId: null,
      ccDateRevDate: null,
      ccDateRevUsrId: null,
      // createdDate: undefined,
      // createdBy: undefined,
      // modifiedDate: undefined,
      // modifiedBy: undefined,
      // revision: undefined,
      polRiskGrps: [],
      polInsdDets: [],
      planNo: null,
      planDesc: null,
      execICDesc: ''
    },
    selectedRiskGrpNo: undefined,
    selectedRiskNo: undefined,
    selectedItemNo: undefined,
    selectedPlanNo: undefined,
    polCrCd: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      },
      polNo: undefined,
      renCnt: undefined,
      endtCnt: undefined,
      effDate: undefined,
      crBank: undefined,
      crCdType: undefined,
      crCdNo: undefined,
      cdSecurNo: undefined,
      cdHolderName: undefined,
      expMth: undefined,
      expYr: undefined,
      entDate: undefined,
      entUsrId: undefined,
      modDate: undefined,
      modUsrId: undefined,
      token: undefined,
      createdDate: undefined,
      createdBy: undefined,
      modifiedDate: undefined,
      modifiedBy: undefined,
      revision: undefined
    },
    polBankDr: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      },
      polNo: undefined,
      renCnt: undefined,
      endtCnt: undefined,
      effDate: undefined,
      drBank: undefined,
      acctNo: undefined,
      acctHolderName: undefined,
      giNo: undefined,
      giStat: undefined,
      submitDate: undefined,
      entDate: undefined,
      entUsrId: undefined,
      modDate: undefined,
      modUsrId: undefined,
      createdBy: undefined,
      createdDate: undefined,
      modifiedBy: undefined,
      modifiedDate: undefined,
      revision: undefined
    },
    polClse: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polHdrStats: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polRiskGrp: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      },
      polNo: undefined,
      renCnt: undefined,
      endtCnt: undefined,
      riskGrpNo: undefined,
      delRiskGrp: undefined,
      noAdult: undefined,
      noChild: undefined,
      planNo: undefined,
      grpUppTxt: undefined,
      grpLwrTxt: undefined,
      grpMemo: undefined,
      grpStdTxt: undefined,
      insdRefNo: undefined,
      titleName: undefined,
      firstName: undefined,
      insdName1: undefined,
      insdName2: undefined,
      insdName3: undefined,
      insdAddr1: undefined,
      insdAddr2: undefined,
      insdAddr3: undefined,
      insdAddr4: undefined,
      insdAddr5: undefined,
      insdAddr6: undefined,
      postCode: undefined,
      // entDate
      // entUsrId
      // modDate
      // modUsrId
      noLive: undefined,
      insdName4: undefined,
      insdPremises: undefined
      // createdDate
      // createdBy
      // modifiedDate
      // modifiedBy
      // revision
    },
    polInsdDet: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polRisk: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      },
      riskList: []
    },
    riskClse: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polRiskStats: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polRiskBlk: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polFireRisk: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polMiscWrkman: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      },
      polMiscWrkmanList: []
    },
    polMiscEmpyt: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polMtrRisk: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polMtrDrv: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      },
      polMtrDrvList: []
    },
    polHullRisk: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polCargoRisk: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polItem: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      },
      stdItemTxtRef: undefined,
      stdItemTxtLn: undefined
    },
    polItemStats: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polItemUOM: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: [],
        types: []
      },
      uom: undefined,
      uomShortDesc: undefined,
      uomVal: undefined
    },
    polSubItem: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: [],
        types: []
      }
    },
    polItemBen: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    riskTrailer: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    premInstalBill: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polBordItem: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polEmpyeeDet: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    polCoinsSvcFee: {
      init: 0,
      saving: false,
      saveError: {
        fieldMessages: [],
        messages: []
      }
    },
    stepForm: {
      step: 1
    }
  },
  policyHeaderSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policyRiskGroupSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policyRiskSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policyFireRiskSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policyBondRiskSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policyMotorRiskSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policyHullRiskSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policyCargoRiskSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policyRiskItemSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policySubItemSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policySummarySettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policyQuerySettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  dataTransferSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  specialFuncUWSettings: {
    init: 0,
    initErr: [],
    menu: {},
    riskSurveySettings: {
      init: 0,
      initErr: [],
      menu: {}
    },
    riskSurveyMaster: {
      survNo: null,
      verCnt: 0,
      survId: undefined,
      survDate: new Date(),
      polNo: undefined,
      insdName: undefined,
      bldgNo: undefined,
      unitNo: undefined,
      addr1: undefined,
      addr2: undefined,
      addr3: undefined,
      addr4: undefined,
      postCode: undefined,
      survType: undefined,
      extPhoto: false,
      intPhoto: false,
      plans: false,
      adjUnit: undefined,
      contactName: undefined,
      telNo: undefined,
      nxtSurvBy: undefined,
      updDate: undefined,
      recomComp: undefined,
      remarks: undefined,
      uwIdConv: undefined,
      resurvDate: undefined
    },
    riskSurveyDetails: {
      survNo: null,
      verCnt: 0,
      survDetType: undefined,
      constnCls: undefined,
      yrBlt: undefined,
      preWar: false,
      refurbish: false,
      wall: undefined,
      roof: undefined,
      floor: undefined,
      stairs: undefined,
      noOpen: undefined,
      noFireChkDoor: undefined,
      constnType: undefined,
      extn: false,
      extnConstn: undefined,
      noUnitTerr: undefined,
      occpnTerr: undefined,
      noUnitHr: undefined,
      occpnHr: undefined,
      strataTitle: undefined,
      nearBldg: undefined,
      adjUnitOccpn: undefined,
      fencedUp: false,
      securGrd: false,
      onSlope: false,
      retStrc: false,
      river: false,
      floodProne: false,
      wiringType: undefined,
      cbType: undefined,
      noGen: undefined,
      extType: undefined,
      noExt: undefined,
      inspDate: undefined,
      noHoseReel: undefined,
      spr: false,
      smokeDet: false,
      fireAlrm: false,
      dryRiser: false,
      wetRiser: false,
      hydrant: false,
      fireDrill: false,
      nearFireSt: undefined,
      clean: undefined,
      layout: undefined,
      vent: undefined,
      smokeReg: false,
      wasteDisp: undefined,
      wasteDispFreq: undefined,
      insdBldg: 0,
      insdCont: 0,
      insdPlt: 0,
      insdRawMat: 0,
      insdGoods: 0,
      insdPackMat: 0,
      occpnCls: undefined,
      goodsType: undefined,
      goodsFlam: undefined,
      packType: undefined,
      storeArr: undefined,
      stacksHgt: undefined,
      whsType: undefined,
      othTent: false,
      part: false,
      partType: undefined,
      othTentGoods: undefined,
      constnRemarks: undefined,
      surrRemarks: undefined,
      ltgRemarks: undefined,
      firePrevRemarks: undefined,
      mgmtRemarks: undefined,
      occpnRemarks: undefined,
      fireAttchRemarks: undefined,
      stkType: undefined,
      stkVal: 0,
      highVal: 0,
      invRec: undefined,
      onPrem: false,
      noOnPrem: undefined,
      hrsEmpty: undefined,
      alrmType: undefined,
      alrmConn: undefined,
      wtchmen: false,
      wtchmenArmd: false,
      wtchmenHrs: undefined,
      mainEntDrMat: undefined,
      mainEntProt: undefined,
      mainEntLock: undefined,
      othEntDrMat: undefined,
      othEntProt: undefined,
      othEntLock: undefined,
      windMat: undefined,
      windProt: undefined,
      windLock: undefined,
      safeMake: undefined,
      safeDim: undefined,
      safeLock: undefined,
      safeConcld: false,
      premRemarks: undefined,
      entRemarks: undefined,
      lossRemarks: undefined,
      remarks: undefined,
      burgRemarks: undefined
    }
  },
  deletePolicySettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  customerLogSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  coinsSvcFeeSettings: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

export default {
  // deep clone here, we need the initialState for resetting of state in ClaimNew
  state: clone(initialState),
  getters,
  mutations,
  actions
}
